<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Korrektion af timer" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div>
			<form-grid-layout>
				<div v-for="(emp, idx) in ent._embedded.hours.union" :key="idx">
					<form-line-layout>
						<clock-select-view :label="emp.name" v-model="emp.hours" :controller="$store.state.popupController" />
					</form-line-layout>
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view v-if="false" label="Nulstil" @click="onResetButtonClick" />
			<button-view label="Godkend" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import MoveTaskModel from '../model/MoveTask'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	import { bus } from '../../bus';

	const stop = {

	};

	export default {
		data: function () {
			return {
				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				types: [],
				status: [],
				employees: [],
				vehicles: [],



				ent: {
					id: null,
					_embedded: {
						hours: {
							status: '',
							calculated: [],
							approved: [],
							union: []
						}
					}
				}
			};
		},
		watch: {
			'ent.extra': {
				handler(n) {
					
				}
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: this.ent.name
					}
				];
			},
			_employees() {
				return this.employees.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			},
			_vehicles() {
				return this.vehicles.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			}
		},
		props: {
			id: Number,
			form: Boolean,
			from_date: String,
			from_time: String,
			to_date: String,
			to_time: String,
			submit: {
				type: Function,
				default: function () {}
			},
			reset: {
				type: Function,
				default: function () {}
			},
			entity: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.ent._embedded.hours.union);
			},
			async onResetButtonClick() {
				//
				//this.submit(this.ent);

				
				this.reset(this.ent);
			}
		},
		mounted: function() {
			
			

			var self = this;

			

			this.ent = merge(this.ent, this.entity);

			

			// Correnct hours
			

			for (var i = 0; i < this.ent._embedded.hours.union.length; ++i) {
				this.ent._embedded.hours.union[i].hours = Math.round(this.$options.filters.roundHours(this.ent._embedded.hours.union[i].hours) * 60);
			}

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
